'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var mafmt = require('mafmt');

var multiaddr = require('multiaddr');

var PeerId = require('peer-id');

var PeerInfo = require('peer-info');

var withIs = require('class-is');

var _require = require('./protocol'),
    CircuitPB = _require.CircuitRelay;

var debug = require('debug');

var log = debug('libp2p:circuit');
log.error = debug('libp2p:circuit:error');

var toConnection = require('libp2p-utils/src/stream-to-ma-conn');

var _require2 = require('./multicodec'),
    multicodec = _require2.relay;

var _createListener = require('./listener');

var _require3 = require('./circuit/hop'),
    handleCanHop = _require3.handleCanHop,
    handleHop = _require3.handleHop,
    hop = _require3.hop;

var _require4 = require('./circuit/stop'),
    handleStop = _require4.handleStop;

var StreamHandler = require('./circuit/stream-handler');

var Circuit = /*#__PURE__*/function () {
  /**
   * Creates an instance of Circuit.
   *
   * @constructor
   * @param {object} options
   * @param {Libp2p} options.libp2p
   * @param {Upgrader} options.upgrader
   */
  function Circuit(_ref) {
    var libp2p = _ref.libp2p,
        upgrader = _ref.upgrader;

    _classCallCheck(this, Circuit);

    this._dialer = libp2p.dialer;
    this._registrar = libp2p.registrar;
    this._upgrader = upgrader;
    this._options = libp2p._config.relay;
    this.peerInfo = libp2p.peerInfo;

    this._registrar.handle(multicodec, this._onProtocol.bind(this));
  }

  _createClass(Circuit, [{
    key: "_onProtocol",
    value: function () {
      var _onProtocol2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var connection, stream, protocol, streamHandler, request, circuit, virtualConnection, remoteAddr, localAddr, maConn, type, conn;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                connection = _ref2.connection, stream = _ref2.stream, protocol = _ref2.protocol;
                streamHandler = new StreamHandler({
                  stream: stream
                });
                _context.next = 4;
                return streamHandler.read();

              case 4:
                request = _context.sent;
                circuit = this;
                _context.t0 = request.type;
                _context.next = _context.t0 === CircuitPB.Type.CAN_HOP ? 9 : _context.t0 === CircuitPB.Type.HOP ? 13 : _context.t0 === CircuitPB.Type.STOP ? 18 : 23;
                break;

              case 9:
                log('received CAN_HOP request from %s', connection.remotePeer.toB58String());
                _context.next = 12;
                return handleCanHop({
                  circuit: circuit,
                  connection: connection,
                  streamHandler: streamHandler
                });

              case 12:
                return _context.abrupt("break", 24);

              case 13:
                log('received HOP request from %s', connection.remotePeer.toB58String());
                _context.next = 16;
                return handleHop({
                  connection: connection,
                  request: request,
                  streamHandler: streamHandler,
                  circuit: circuit
                });

              case 16:
                virtualConnection = _context.sent;
                return _context.abrupt("break", 24);

              case 18:
                log('received STOP request from %s', connection.remotePeer.toB58String());
                _context.next = 21;
                return handleStop({
                  connection: connection,
                  request: request,
                  streamHandler: streamHandler,
                  circuit: circuit
                });

              case 21:
                virtualConnection = _context.sent;
                return _context.abrupt("break", 24);

              case 23:
                log('Request of type %s not supported', request.type);

              case 24:
                if (!virtualConnection) {
                  _context.next = 35;
                  break;
                }

                remoteAddr = multiaddr(request.dstPeer.addrs[0]);
                localAddr = multiaddr(request.srcPeer.addrs[0]);
                maConn = toConnection({
                  stream: virtualConnection,
                  remoteAddr: remoteAddr,
                  localAddr: localAddr
                });
                type = CircuitPB.Type === CircuitPB.Type.HOP ? 'relay' : 'inbound';
                log('new %s connection %s', type, maConn.remoteAddr);
                _context.next = 32;
                return this._upgrader.upgradeInbound(maConn);

              case 32:
                conn = _context.sent;
                log('%s connection %s upgraded', type, maConn.remoteAddr);
                this.handler && this.handler(conn);

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _onProtocol(_x) {
        return _onProtocol2.apply(this, arguments);
      }

      return _onProtocol;
    }()
    /**
     * Dial a peer over a relay
     *
     * @param {multiaddr} ma - the multiaddr of the peer to dial
     * @param {Object} options - dial options
     * @param {AbortSignal} [options.signal] - An optional abort signal
     * @returns {Connection} - the connection
     */

  }, {
    key: "dial",
    value: function () {
      var _dial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ma, options) {
        var addrs, relayAddr, destinationAddr, relayPeer, destinationPeer, disconnectOnFailure, relayConnection, virtualConnection, localAddr, maConn;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Check the multiaddr to see if it contains a relay and a destination peer
                addrs = ma.toString().split('/p2p-circuit');
                relayAddr = multiaddr(addrs[0]);
                destinationAddr = multiaddr(addrs[addrs.length - 1]);
                relayPeer = PeerId.createFromCID(relayAddr.getPeerId());
                destinationPeer = PeerId.createFromCID(destinationAddr.getPeerId());
                disconnectOnFailure = false;
                relayConnection = this._registrar.getConnection(new PeerInfo(relayPeer));

                if (relayConnection) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 10;
                return this._dialer.connectToPeer(relayAddr, options);

              case 10:
                relayConnection = _context2.sent;
                disconnectOnFailure = true;

              case 12:
                _context2.prev = 12;
                _context2.next = 15;
                return hop({
                  connection: relayConnection,
                  circuit: this,
                  request: {
                    type: CircuitPB.Type.HOP,
                    srcPeer: {
                      id: this.peerInfo.id.toBytes(),
                      addrs: this.peerInfo.multiaddrs.toArray().map(function (addr) {
                        return addr.buffer;
                      })
                    },
                    dstPeer: {
                      id: destinationPeer.toBytes(),
                      addrs: [multiaddr(destinationAddr).buffer]
                    }
                  }
                });

              case 15:
                virtualConnection = _context2.sent;
                localAddr = relayAddr.encapsulate("/p2p-circuit/p2p/".concat(this.peerInfo.id.toB58String()));
                maConn = toConnection({
                  stream: virtualConnection,
                  remoteAddr: ma,
                  localAddr: localAddr
                });
                log('new outbound connection %s', maConn.remoteAddr);
                return _context2.abrupt("return", this._upgrader.upgradeOutbound(maConn));

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2["catch"](12);
                log.error('Circuit relay dial failed', _context2.t0);
                _context2.t1 = disconnectOnFailure;

                if (!_context2.t1) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 29;
                return relayConnection.close();

              case 29:
                throw _context2.t0;

              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[12, 22]]);
      }));

      function dial(_x2, _x3) {
        return _dial.apply(this, arguments);
      }

      return dial;
    }()
    /**
     * Create a listener
     *
     * @param {any} options
     * @param {Function} handler
     * @return {listener}
     */

  }, {
    key: "createListener",
    value: function createListener(options, handler) {
      if (typeof options === 'function') {
        handler = options;
        options = {};
      } // Called on successful HOP and STOP requests


      this.handler = handler;
      return _createListener(this, options);
    }
    /**
     * Filter check for all Multiaddrs that this transport can dial on
     *
     * @param {Array<Multiaddr>} multiaddrs
     * @returns {Array<Multiaddr>}
     */

  }, {
    key: "filter",
    value: function filter(multiaddrs) {
      multiaddrs = Array.isArray(multiaddrs) ? multiaddrs : [multiaddrs];
      return multiaddrs.filter(function (ma) {
        return mafmt.Circuit.matches(ma);
      });
    }
  }]);

  return Circuit;
}();
/**
 * @type {Circuit}
 */


module.exports = withIs(Circuit, {
  className: 'Circuit',
  symbolName: '@libp2p/js-libp2p-circuit/circuit'
});